<template>
    <div>
        <q-modal v-model="add_model" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @show="clearQuestions()" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideQuestionModal('cancel', '')" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('evaluation_model') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-12">
                            <q-select v-model="webcast_base_evaluation_id" :options="model_types" :float-label="$t('model_type')" :error="$v.webcast_base_evaluation_id.$error" @input="$v.webcast_base_evaluation_id.$touch" />
                        </div>
                    </div>

                    <q-table
                        :data="questions"
                        :columns="columns"
                        :pagination.sync="server_pagination"
                        @request="request_questions"
                        :loading="loading"
                        row-key="id"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[0]"
                        binary-state-sort
                        class="q-mt-lg"
                        >
                        <template slot="top" slot-scope="props">
                            <div class="q-table-title">{{ $t('questions') }}</div>
                        </template>

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td auto-width key="id" :props="props">
                                {{ props.row.id }}
                            </q-td>

                            <q-td key="title" :props="props">
                                {{ props.row.title }}
                            </q-td>

                            <q-td key="question_type" :props="props">
                                {{ getEvaluationType(props.row.question_type) }}
                            </q-td>
                        </q-tr>
                    </q-table>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-ban" @click="hideQuestionModal('cancel', '')" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveQuestion()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue } from 'vuelidate/lib/validators'

export default {
    props: ['id_webcast', 'add_model', 'model_types', 'test_types'],

    i18nOptions: { namespaces: ['common', 'training', 'admin'] },

    data() {
        return {
            webcast_base_evaluation_id: '',
            questions: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: true,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'question',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'question_type',
                    required: true,
                    label: 'question_type',
                    align: 'left',
                    field: 'question_type',
                    sortable: true,
                }
            ],
            loading: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        request_questions({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.$axios.get(`/admin_webcasts/base_evaluations/${this.webcast_base_evaluation_id}/base_evaluation_questions/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.questions = []

                response.data.forEach(result => {
                    this.questions.push({
                        id: result.id,
                        title: result.title,
                        question_type: result.question_type
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        saveQuestion() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = { 'webcast_base_evaluation_id': this.webcast_base_evaluation_id }

                this.$axios.post(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/create_evaluation_from_base/`, data, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()
                    this.$v.$reset()

                    this.$q.notify({
                        message: this.$t('question_model_add_success'),
                        type: 'positive',
                        icon: 'far fa-save'
                    })

                    this.hideQuestionModal('save', response.data.id)
                })
                .catch(e => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('question_model_add_error'),
                        type: 'negative',
                        icon: 'fas fa-ban'
                    })

                    console.log(e)
                })
            }
        },

        clearQuestions() {
            this.$v.$reset()
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getEvaluationType(id) {
            let obj = this.test_types.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        hideQuestionModal(type, id) {
            this.webcast_base_evaluation_id = ''
            this.questions = []
            this.$v.$reset()

            this.$emit('returnToQuestionsFromModel', {'type': type, 'id': id} )
        }
    },

    watch: {
        webcast_base_evaluation_id: function() {
            if (this.webcast_base_evaluation_id) this.request_questions({ pagination: this.server_pagination })
        }
    },

    validations() {
        return {
            webcast_base_evaluation_id: { required },
        }
    }
}
</script>

<style>

</style>
